import React from 'react';

import Delete from 'Components/Partials/Modals/Delete';
import {IndexTable} from 'Components/Utilities';
import {MultipleChoiceFilter} from 'Components/Filters';

import AdminLayout from 'Pages/Admin/AdminLayout';

import ElementApi from 'Services/Api/Admin/Cms/Elements/Element';
import {translationFromJson} from 'Services/TranslationHelpers2';
import User from 'Services/User';

export default class AdminCmsElementsIndex extends React.Component {
    /**
     * @var columns
     * @type {array}
     */
    columns = [
        {
            label: 'Label',
            value: (record) => translationFromJson(record.label),
            type: 'callback',
            orderable: null
        },
        {
            label: 'Attach To Service User (Narrative)',
            value: 'attach_to_service_user',
            type: 'boolean',
            orderable: 'attach_to_service_user'
        },
        {
            label: 'Health & Safety',
            value: 'health_and_safety',
            type: 'boolean',
            orderable: 'health_and_safety'
        },
        {
            label: 'Quality Assurance',
            value: 'quality_assurance',
            type: 'boolean',
            orderable: 'quality_assurance'
        },
        {
            label: 'Medication Management',
            value: 'medication_management',
            type: 'boolean',
            orderable: 'medication_management'
        },
        {
            label: 'Staff Form',
            value: 'staff_form',
            type: 'boolean',
            orderable: 'staff_form'
        },
        {
            label: 'Archived',
            value: 'archived',
            type: 'boolean',
            orderable: 'archived'
        },
        {
            label: 'Services',
            value: (record) => record.all_services ?
                'All services' :
                ((record.services ?? []).map(service => service.name).join(', ') || 'None'),
            type: 'callback',
            orderable: null,
            services_enabled: true,
            filters: [
                {
                    column: 'service_id',
                    label: 'Service',
                    component: MultipleChoiceFilter,
                    defaultMethod: false,
                    props: {
                        options: (User.data?.service_access?.services ?? []).map(service => ({
                            label: service.name,
                            value: service.id
                        }))
                    }
                }
            ]
        },
    ];

    /**
     * @method getRowActions
     * @param {object} item
     */
    getRowActions = (item) => {
        return [
            {
                type: "link",
                to: "/admin/cms/elements/show/"+item.id,
                text: "Manage"
            },
            {
                type: "modalTrigger",
                component: Delete,
                props: {
                    itemName: 'element',
                    itemId: item.id,
                    onDeleteApi: ElementApi.delete
                },
                text: 'Delete'
            },
            {
                type: "link",
                to: "/admin/cms/elements/records/"+item.id,
                text: "View Records"
            },
        ];
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        return (
            <AdminLayout title="Forms">
                <IndexTable
                    columns={this.columns}
                    displaySearchBar={false}
                    storeLink="/admin/cms/elements/store"
                    loadDataCallback={(data) => ElementApi.get(null, {
                        ...data,
                        paginate: true
                    })}
                    rowActions={this.getRowActions}
                    rowClickRedirect={(item) => "/admin/cms/elements/show/"+item.id}
                    eventApi={ElementApi}
                />
            </AdminLayout>
        );
    }
}
